import { ExpertisePointGroupType } from './index';

export interface CheckCampaignResponse {
  hasCampaign: boolean;
  campaignId?: number;
  campaignMatchingId?: number;
  campaignName?: string;
  campaignExpireDate?: Date;
  discountRate?: number;
  discountRateStr?: string;
}

export interface CampaignExpertisePoint {
  id: number;
  name: string;
}

export interface CampaignItem {
  id: number;
  expertisePackageName: string;
  price: number;
  quantity?: number;
}

export interface Campaign {
  id: number;
  name: string;
  code?: string;
  campaignName?: string;
  campaignCode?: string;
  description?: string;
  discountRate?: number;
  startDate?: string;
  endDate?: string;
  active: boolean;
  usageLimit?: number | null;
  perUserUsageLimit?: number | null;
  expertisePoints?: CampaignExpertisePoint[];
  termsAndConditions?: string;
  discountAvailable?: boolean;
  maxDiscountRate?: string;
  items?: CampaignItem[];
  isActive: boolean;
  discountRateStr?: string;
  groupType?: ExpertisePointGroupType;
}

export interface SaveCampaignRequest {
  id?: number;
  campaignName: string;
  campaignCode: string;
  description?: string;
  termsAndConditions?: string;
  discountRate: number;
  totalUsageLimit?: number;
  perUserUsageLimit?: number;
  startDate: Date;
  endDate: Date;
  expertisePoints?: number[];
  isActive: boolean;
  groupType: ExpertisePointGroupType;
}

export interface CampaignListResponse {
  campaigns: Campaign[];
}

export interface SaveCampaignMatchingRequest {
  campaignId: number;
  phoneNumber: string;
  name: string;
  govId?: string;
  usageLimit?: number;
}

export interface UpdateCampaignMatchingRequest {
  id: number;
  usageLimit?: number;
}

export interface CampaignMatchingFilterRequest {
  searchTerm?: string;
  campaignId?: number;
  groupType?: ExpertisePointGroupType;
}

export const enum CampaignQueryCacheKey {
  GetCampaignList = 'GetCampaignList',
}

export interface BulkCampaignMatchingResult {
  phoneNumber: string;
  campaignCode: string;
  name: string;
  errorMessage: string;
}

export interface CampaignMatchingData {
  id: number;
  campaignId: number;
  phoneNumber: string;
  name: string;
  govId?: string;
  usageLimit?: number;
  createdAt: string;
  updatedAt: string;
  campaignName: string;
  campaignCode: string;
  discountRate: number;
  discountRateStr: string;
  campaignEndDate: string;
  campaignStartDate: string;
  usedCount: number;
  remainingUsage: number;
}
